var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseX = function SvgCloseX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d490f",
    d: "m20.69 15 8.53-8.53a2.68 2.68 0 0 0 0-3.79l-1.9-1.9a2.68 2.68 0 0 0-3.8 0L15 9.31 6.47.78a2.68 2.68 0 0 0-3.79 0l-1.9 1.9a2.68 2.68 0 0 0 0 3.8L9.31 15 .78 23.53a2.68 2.68 0 0 0 0 3.79l1.9 1.9a2.68 2.68 0 0 0 3.8 0L15 20.69l8.53 8.53a2.68 2.68 0 0 0 3.79 0l1.9-1.9a2.68 2.68 0 0 0 0-3.8L20.69 15Z"
  })));
};
export default SvgCloseX;